const PRIVACY_POLICY_PATHS = new Set(['/privacy', '/privacy/']);
const EXTENSION_SIGNUP_PATHS = new Set(['/extension-signup', '/extension-signup/']);
const TRACKER_ACTIVITY_PATHS = new Set(['/bookmarks/tracker', '/bookmarks/tracker/']);
const MCP_AUTHORIZATION_PATHS = new Set(['/mcp/authorize', '/mcp/authorize/']);

const toPathname = (value = '') => {
    const normalizedValue = `${value || ''}`.trim();
    if (!normalizedValue) {
        return '';
    }

    try {
        return new URL(normalizedValue, 'https://animebookmark.com').pathname;
    } catch (_error) {
        return normalizedValue.split(/[?#]/u, 1)[0];
    }
};

export const isPrivacyPolicyPath = (value = '') => PRIVACY_POLICY_PATHS.has(toPathname(value));

export const isExtensionSignupPath = (value = '') => EXTENSION_SIGNUP_PATHS.has(toPathname(value));

export const isMcpAuthorizationPath = (value = '') => MCP_AUTHORIZATION_PATHS.has(toPathname(value));

export const isAnalyticsSuppressedPath = (value = '') => (
    isPrivacyPolicyPath(value)
    || isExtensionSignupPath(value)
    || TRACKER_ACTIVITY_PATHS.has(toPathname(value))
    || isMcpAuthorizationPath(value)
);

export const isCurrentPrivacyPolicyPath = () => (
    typeof window !== 'undefined'
    && isPrivacyPolicyPath(window.location?.pathname || '')
);

export const isCurrentExtensionSignupPath = () => (
    typeof window !== 'undefined'
    && isExtensionSignupPath(window.location?.pathname || '')
);

export const isCurrentAnalyticsSuppressedPath = () => (
    typeof window !== 'undefined'
    && isAnalyticsSuppressedPath(window.location?.pathname || '')
);
